export default __webpack_public_path__ + "static/media/backgroundMobile.619b31bf.jpg";